import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle, Award, Users, TrendingUp, Shield, Sparkles } from 'lucide-react';

const AboutSection = () => {
  const { t } = useLanguage();

  const icons = [Award, Users, Shield, TrendingUp, Sparkles, CheckCircle];

  return (
    <section id="about" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Content */}
          <div>
            <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-3">
              Sobre Nós
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
              {t.about.title}
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              {t.about.description}
            </p>

            {/* Highlights Grid */}
            <div className="grid sm:grid-cols-2 gap-4">
              {t.about.highlights.map((highlight, index) => {
                const IconComponent = icons[index];
                return (
                  <div
                    key={index}
                    className="flex items-start gap-3 p-4 bg-slate-50 rounded-xl hover:bg-teal-50 transition-colors group"
                  >
                    <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-teal-200 transition-colors">
                      {IconComponent && <IconComponent className="w-4 h-4 text-teal-600" />}
                    </div>
                    <span className="text-slate-700 text-sm font-medium">
                      {highlight}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right - Image */}
          <div className="relative">
            {/* Background Decorations */}
            <div className="absolute -top-4 -left-4 w-20 h-20 bg-teal-100 rounded-2xl opacity-60" />
            <div className="absolute -bottom-4 -right-4 w-28 h-28 bg-emerald-100 rounded-2xl opacity-60" />
            
            {/* Main Image Container */}
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_contaserve/artifacts/i47g9uwp_different-people-brainstorming-work-meeting.jpg"
                alt="Equipa profissional em reunião"
                className="w-full h-auto object-cover aspect-[4/3]"
              />
              
              {/* Stats Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <div className="grid grid-cols-3 gap-4 text-white text-center">
                  <div>
                    <div className="text-2xl font-bold">20+</div>
                    <div className="text-xs text-white/80">Anos</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold">500+</div>
                    <div className="text-xs text-white/80">Clientes</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold">98%</div>
                    <div className="text-xs text-white/80">Satisfação</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -top-6 -right-6 bg-white rounded-xl shadow-lg p-4 border border-slate-100">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
                  <Award className="w-5 h-5 text-teal-600" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-slate-900">Certificados</div>
                  <div className="text-xs text-slate-500">Profissionais</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
